// Mixins
import { GoogleAnalyticsMixins } from "@/app/mixins/utils/google-analytics-mixins"

// Constants
import { GA } from "@/app/constants/ga-constants"
import { BREEDER_ROUTES } from '@/app/constants/breeder-routes-constants';

// Mixins
import { comingSoonMixins } from "@/app/mixins/utils/coming-soon-mixins"
import { userMixins } from "@/app/mixins/modules/user-mixins.js"

// Components
const DropdownMenu = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: 'notification-component' */ "@/app/views/main-view/_shared/_utilities/profile-dropdown-menu/profile-dropdown-menu.vue"
	)

export default {
	name: "ClientHeader",
	mixins: [GoogleAnalyticsMixins, comingSoonMixins, userMixins],
	components: {
		DropdownMenu,
	},
	props: {
		showMainLogo: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			SIGN_IN: "Sign In",
			SIGN_UP: "Sign Up",
			isHeaderSticky: false,
			PUPPY_SALES_ROUTE: BREEDER_ROUTES.PUPPY_SALES,
		}
	},
	mounted() {
		window.addEventListener("scroll", this.handleScroll)
	},
	beforeDestroy() {
		window.removeEventListener("scroll", this.handleScroll)
	},
	computed: {
		getLoggedInStatus() {
			const userDetails = this.$store.getters.getUserDetails

			if (userDetails) {
				return userDetails.id ? this.SIGN_IN : this.SIGN_UP
			}
		},
		isLandingPage() {
			return this.$route.name === "Landing Page"
		},
		isUserLoggedIn() {
			const token = this.$store.getters.getUserToken

			return !!token
		},
		userRole() {
			return this.$store.getters.getUserDetails.userRole
		},
	},
	methods: {
		sendWebAppButtonAnalytics() {
			this.sendEventTrackingToGA(
				`${GA.LANDING_PAGE.USE_WEB_APP_BUTTON.ACTION}`,
				`${GA.LANDING_PAGE.CATEGORY}`,
				`${GA.LANDING_PAGE.USE_WEB_APP_BUTTON.LABEL}`
			)
		},
		useWebApp(url) {
			if (this.getLoggedInStatus === this.SIGN_IN) {
				this.$router.push(this.userRole === "BRDER" ? BREEDER_ROUTES.PUPPY_SALES : "/dashboard")
			} else {
				this.$router.push(url)
			}
			this.sendWebAppButtonAnalytics()
		},
		goToMain() {
			if (this.$route.path != "/") {
				this.$router.push("/")
			}
		},
		goToSection(section) {
			if (this.$route.name !== "Landing Page") {
				this.$router.push(`/${section}`)
			} else {
				window.location.href = section
			}
		},
		logoutUser() {
			this.$store.dispatch("logout")
		},

		handleScroll() {
			this.isHeaderSticky = window.scrollY > 0
		},
		handleClickLogo() {
			if (this.$route.path === '/') {
      			window.scrollTo({ top: 0 });
    		}
		},
		handleClickPuppyForSale(event) {
			// alert(this.$route.path)
			// Prevent default link behavior
			event.preventDefault();
			// Programmatically navigate to the current URL
			// this.$router.push(this.$route.path)
			if(this.$route.path === '/puppy-for-sale') {
				window.location.reload(); 
			}
		  }
	},
}
